import React, { useState, useEffect } from "react";
import { GetBatches } from "../../../services/BatchService";
import MicroOutForm from "../MicroOutForm";
import { appInsights } from "../../../services/appInisights";
import { NotificationManager } from "react-notifications";
import CommonLoader from "../../../vlp/components/common/CommonLoader";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  TableSortLabel,
  IconButton,
  Box,
  FormControl,
  MenuItem,
  InputLabel,
  Select,
  Button,
  DialogActions,
  Dialog,
  DialogTitle,
  DialogContent,
  FormHelperText, Collapse
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";
import { GetUsers } from "../../../services/usersService";
import { formatDateTime } from "../../../common-utilities/date-utility";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

export default function IncubatorOutBatches() {
  const [selectedBatch, setSelectedBatch] = useState({});
  const [batches, setBatches] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("id");
  const [selectedBatchFilter, setSelectedBatchFilter] = useState("");
  const [selectedLocationFilter, setSelectedLocationFilter] = useState("");
  const [selectedUserFilter, setSelectedUserFilter] = useState("");
  const [openPopup, setOpenPopup] = useState(false);
  const [users, setUsers] = useState([]);
  const [expandedBatchId, setExpandedBatchId] = useState(null);

  useEffect(() => {
    fetchUsers();
    loadBatches();
  }, []);

  const fetchUsers = async () => {
    try {
      const users = await GetUsers("ANALYSTS");
      setUsers(users);
    } catch (error) {
      NotificationManager.error("Failed to get Users:", error.message);
    }
  };
  async function loadBatches() {
    setLoading(true);
    try {
      let b = await GetBatches();
      setOpenPopup(false);
      if (b) {
        setBatches(b);
        setSelectedBatch(b.length > 0 ? b[0] : {});
      } else {
        NotificationManager.info("No pending batches found");
      }
    } catch (err) {
      appInsights.trackException({
        error: err,
        properties: { message: "Failed to get batches from API" },
      });
      NotificationManager.error("Unable to get batches", "Error");
    } finally {
      setLoading(false);
    }
  }

  const toggleExpandRow = (batchId) => {
    setExpandedBatchId(expandedBatchId === batchId ? null : batchId);
  };

  const handleChangePage = (event, newPage) => setPage(newPage);

  const determineTimeRange = (item) => {
    // Precautionary checks
    if (!item) return;
    if (!item.analysisType || !item.color) return;

    const analysisType = item.analysisType;
    const color = item.color;

    const computeTimeRange = (lowerBound, upperBound) => {
      switch (color) {
        case "Grey":
          return `<= ${lowerBound} hours`;
        case "Green":
          return `${lowerBound}-${upperBound} hours`;
        case "Red":
          return `>= ${upperBound} hours`;
        default:
          return "Error";
      }
    };

    switch (true) {
      // Check if analysis type starts with TC
      case /HPC/.test(analysisType):
        // Check if analysis type is HPCDW
        if (/HPCDW/.test(analysisType)) {
          return computeTimeRange(48, 72); // HPCDW==>TimeRange(48, 72)
        } else {
          return computeTimeRange(45, 72); // HPC==>TimeRange(45, 72)
        }
      // Check if analysis type is ecoli
      case /Ecoli/.test(analysisType):
        return computeTimeRange(24, 28);
      // Check if analysis type starts with HPC
      case /^TC/.test(analysisType):
        return computeTimeRange(24, 28);
      default:
        return "Error";
    }
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleClosePopup = () => {
    setOpenPopup(false);
  };
  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const filteredBatches = (Array.isArray(batches) ? batches : []).filter(
    (batch) => {
      return (
        (selectedBatchFilter === "" ||
          batch.analysisType === selectedBatchFilter) &&
        (selectedLocationFilter === "" ||
          batch.location === selectedLocationFilter) &&
        (selectedUserFilter === "" || batch.inUser === selectedUserFilter)
      );
    }
  );

  const sortedBatches = [...filteredBatches].sort((a, b) => {
    if (a[orderBy] < b[orderBy]) return order === "asc" ? -1 : 1;
    if (a[orderBy] > b[orderBy]) return order === "asc" ? 1 : -1;
    return 0;
  });

  const displayedBatches = sortedBatches.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const handleEditClick = (batchId) => {
    const batchToEdit = batches.find((batch) => batch.id === batchId);
    if (batchToEdit) {
      setSelectedBatch(batchToEdit);
      setOpenPopup(true);
    }
  };

  const handleBatchChange = (event) => {
    setSelectedBatchFilter(event.target.value);
  };

  const handleLocationChange = (event) => {
    setSelectedLocationFilter(event.target.value);
  };
  const handleUserChange = (event) => {
    setSelectedUserFilter(event.target.value);
  };
  const handleViewClick = (orderId) => {
    setExpandedBatchId(expandedBatchId === orderId ? null : orderId);
    console.log(`View clicked for order ID: ${orderId}`);
  };

  const handleDeleteClick = (orderId) => {
    console.log(`Delete clicked for order ID: ${orderId}`);
  };

  const renderActions = (orderId) => (
    <div style={{ minWidth: "120px" }}>
      <IconButton
        aria-label="edit"
        style={{ color: "orange" }}
        onClick={() => handleEditClick(orderId)}
      >
        <EditIcon />
      </IconButton>
      <IconButton
        aria-label="view"
        style={{ color: "green" }}
        onClick={() => handleViewClick(orderId)}
      >
        <VisibilityIcon />
      </IconButton>
      <IconButton
        aria-label="delete"
        style={{ color: "red" }}
        onClick={() => handleDeleteClick(orderId)}
      >
        <DeleteIcon />
      </IconButton>
    </div>
  );

  return (
    <div className="vlp-component-container">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <span className="title">MicroManage OUT</span>
      </div>
      <hr />

      <div style={{ display: "flex", gap: "20px", marginBottom: "20px" }}>
        {/* Select Batch */}
        <FormControl sx={{ minWidth: 300 }} variant="outlined" size="small">
          <InputLabel id="select-batch-label">
            Select a batch to filter
          </InputLabel>
          <Select
            labelId="select-batch-label"
            value={selectedBatchFilter}
            onChange={handleBatchChange}
            label="Select a batch to filter"
            fullWidth
          >
            <MenuItem value="">
              <em>All Batches</em>
            </MenuItem>
            {Array.isArray(batches) &&
              [...new Set(batches.map((batch) => batch.analysisType))]
                .sort((a, b) => a.localeCompare(b)) // Sort alphabetically
                .map((analysisType) => (
                  <MenuItem key={analysisType} value={analysisType}>
                    {analysisType}
                  </MenuItem>
                ))}
          </Select>
        </FormControl>

        {/* Select Location */}
        <FormControl sx={{ minWidth: 300 }} variant="outlined" size="small">
          <InputLabel id="select-location-label">
            Select a location to filter
          </InputLabel>
          <Select
            labelId="select-location-label"
            value={selectedLocationFilter}
            onChange={handleLocationChange}
            label="Select a location to filter"
            fullWidth
          >
            <MenuItem value="">
              <em>All Locations</em>
            </MenuItem>
            {Array.isArray(batches) &&
              [...new Set(batches.map((batch) => batch.location))]
                .sort((a, b) => a.localeCompare(b)) // Sort alphabetically
                .map((location) => (
                  <MenuItem key={location} value={location}>
                    {location}
                  </MenuItem>
                ))}
          </Select>
        </FormControl>

        {/* Select User */}
        <FormControl sx={{ minWidth: 300 }} variant="outlined" size="small">
          <InputLabel id="select-user-label">
            Select a In user to filter
          </InputLabel>
          <Select
            labelId="select-user-label"
            value={selectedUserFilter}
            onChange={handleUserChange}
            label="Select a In user to filter"
            fullWidth
          >
            <MenuItem value="">
              <em>All Users</em>
            </MenuItem>
            {Array.isArray(users) &&
              [...new Set(users.map((user) => user.trim()))]
                .sort((a, b) => a.localeCompare(b))
                .map((user) => (
                  <MenuItem key={user} value={user}>
                    {user}
                  </MenuItem>
                ))}
          </Select>
        </FormControl>
      </div>

      <Paper>
        <TableContainer
          sx={{ maxHeight: 500, overflowY: "auto", width: "99%" }}
        >
          <Table sx={{ minWidth: 700 }} size="small" stickyHeader>
            <TableHead
              sx={{
                backgroundColor: (theme) => theme.palette.primary.main,
                color: "white",
              }}
            >
              <TableRow>
                <TableCell>
                  <TableSortLabel
                    active={orderBy === "id"}
                    direction={orderBy === "id" ? order : "asc"}
                    onClick={() => handleRequestSort("id")}
                  >
                    Batch ID
                  </TableSortLabel>
                </TableCell>
                <TableCell>
                  <TableSortLabel
                    active={orderBy === "analysisType"}
                    direction={orderBy === "analysisType" ? order : "asc"}
                    onClick={() => handleRequestSort("analysisType")}
                  >
                    Type
                  </TableSortLabel>
                </TableCell>
                <TableCell>
                  <TableSortLabel
                    active={orderBy === "samplesInBatch"}
                    direction={orderBy === "samplesInBatch" ? order : "asc"}
                    onClick={() => handleRequestSort("samplesInBatch")}
                  >
                    Samples
                  </TableSortLabel>
                </TableCell>
                <TableCell>
                  <TableSortLabel
                    active={orderBy === "inTime"}
                    direction={orderBy === "inTime" ? order : "asc"}
                    onClick={() => handleRequestSort("inTime")}
                  >
                    In Time
                  </TableSortLabel>
                </TableCell>
                <TableCell>
                  <TableSortLabel
                    active={orderBy === "location"}
                    direction={orderBy === "location" ? order : "asc"}
                    onClick={() => handleRequestSort("location")}
                  >
                    Location
                  </TableSortLabel>
                </TableCell>
                <TableCell>
                  <TableSortLabel
                    active={orderBy === "inTime"}
                    direction={orderBy === "inTime" ? order : "asc"}
                    onClick={() => handleRequestSort("inTime")}
                  >
                    Time Span
                  </TableSortLabel>
                </TableCell>
                <TableCell>
                  <TableSortLabel
                    active={orderBy === "inUser"}
                    direction={orderBy === "inUser" ? order : "asc"}
                    onClick={() => handleRequestSort("inUser")}
                  >
                    In User
                  </TableSortLabel>
                </TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {displayedBatches.map((item, index) => (
                <React.Fragment key={item.id}>
                  <TableRow
                    sx={{
                      backgroundColor:
                        index % 2 === 0 ? "rgba(0, 0, 0, 0.04)" : "white",
                    }}
                  >
                    <TableCell style={{ color: item.color }}>
                      {item.id}
                    </TableCell>
                    <TableCell>{item.analysisType}</TableCell>
                    <TableCell>{item.samplesInBatch.length}</TableCell>
                    <TableCell>{formatDateTime(item.inTime)}</TableCell>
                    <TableCell>{item.location}</TableCell>
                    <TableCell style={{ color: item.color }}>
                      {`${determineTimeRange(item)}`}
                    </TableCell>
                    <TableCell>{item.inUser}</TableCell>
                    <TableCell>{renderActions(item.id)}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell
                      style={{ paddingBottom: 0, paddingTop: 0 }}
                      colSpan={8}
                    >
                      <Collapse
                        in={expandedBatchId === item.id}
                        timeout="auto"
                        unmountOnExit
                      >
                        <Box margin={1}>
                          <Table size="small">
                            <TableHead>
                              <TableRow>
                                <TableCell>Sample ID</TableCell>
                                <TableCell>Sample Lab ID</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {item.samplesInBatch?.length > 0 ? (
                                item.samplesInBatch.map((sample) => (
                                  <TableRow key={sample.id}>
                                    <TableCell>{sample.id}</TableCell>
                                    <TableCell>
                                      {sample.sampleLabId}
                                    </TableCell>
                                  </TableRow>
                                ))
                              ) : (
                                <TableRow>
                                  <TableCell colSpan={2} align="center">
                                    No Samples Found
                                  </TableCell>
                                </TableRow>
                              )}
                            </TableBody>
                          </Table>
                        </Box>
                      </Collapse>
                    </TableCell>
                  </TableRow>
                </React.Fragment>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          rowsPerPageOptions={[10, 20, 50, 100]}
          component="div"
          count={filteredBatches.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>

      {/* Popup for MicroOutForm */}
      <Dialog
        open={openPopup}
        onClose={handleClosePopup}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle></DialogTitle>
        <DialogContent>
          <MicroOutForm
            model={selectedBatch}
            onSuccess={loadBatches}
            callBack={setBatches}
            isFromVlp={true}
            users={users}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClosePopup} color="secondary">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <CommonLoader loading={loading} />
    </div>
  );
}
